import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useToast } from 'hooks/ui';
import { resetUserHomePageSettings } from 'api/appSettings.service';
import { HomePageWidgets_queryKey } from './constants';

/**
 * Resets the current admin's layout to the global default for their role
 * DELETE /admins/me/settings/home-page
 */
export const useResetHomePageWidgetsQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation<void, AxiosError, void>({
    mutationFn: resetUserHomePageSettings,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [HomePageWidgets_queryKey] });
      toast.success('Home Page widgets layout has been reset to default');
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
    onSettled: () => {
      // Invalidate the query to ensure we fetch the freshest data from the server
      queryClient.invalidateQueries({ queryKey: [HomePageWidgets_queryKey] });
    },
  });

  return { isLoading: isPending, mutate };
};
